import { render, staticRenderFns } from "./AddressBookEditPopup.vue?vue&type=template&id=b3c64002&scoped=true&"
import script from "./AddressBookEditPopup.vue?vue&type=script&lang=js&"
export * from "./AddressBookEditPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c64002",
  null
  
)

export default component.exports